<template>
<div>
    <m-settings-organization-rate-card-ctrl
        :organization_id="this.$route.params.organization_id"
        compact
    />

    <p>
        <v-switch
            label="This section is complete"
            v-model="profile.provision_info.complete_rate_card"
            v-on:change="onChangeCompleteSwitch"
        />
    </p>

</div>
</template>

<script>
export default {
    props: {
         profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onChangeCompleteSwitch() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/provision/provision-info',
            
                'params' : this.profile.provision_info,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to mark the rate card section as complete',
            });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>